import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { RootDispatch } from '../../store';
import { Message, SenderStatus } from '../../types';
import styles from './MessageStatusFailedRetry.module.css';

export function MessageStatusFailedRetry({
  recallMessage,
  retryMessage,
  message,
  senderStatus,
}: {
  recallMessage: (messageId: string) => void;
  retryMessage: (messageId: string) => void;
  message: Message;
  senderStatus: string;
}) {
  if (!message) return null;
  const { id: messageId } = message;

  const isRetrying = senderStatus === SenderStatus.Retrying;
  let retryButtonText;
  let retryButtonStyleType;
  if (isRetrying) {
    retryButtonText = 'Sending...';
    retryButtonStyleType = 'retryButtonSending';
  } else {
    retryButtonText = 'Resend';
    retryButtonStyleType = 'retryButtonTappable';
  }

  return (
    <div className={styles.messageStatusFailedRetryContainer}>
      <button
        className={styles.deleteButton}
        onClick={() => {
          recallMessage(messageId);
        }}
        disabled={isRetrying}
      >
        {'Delete'}
      </button>
      <button
        className={classNames(styles.retryButton, styles[retryButtonStyleType])}
        onClick={() => {
          retryMessage(messageId);
        }}
        disabled={isRetrying}
      >
        {retryButtonText}
      </button>
    </div>
  );
}

const mapDispatch = ({ messages: { recallMessage, retryMessage } }: RootDispatch) => ({
  recallMessage,
  retryMessage,
});

// https://tigertext.atlassian.net/browse/TMG-837
// @ts-expect-error
export default connect(null, mapDispatch)(MessageStatusFailedRetry);
